import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Config from "src/Constants/Config";
import store from "src/Reducers/store";
import setCurrentPage from "src/Utils/setCurrentPage";
import ExtraDescription from "src/Component/ExtraDescription";

const PageId = 3;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const [step, setStep] = useState(0);
  const videoRef = useRef<HTMLVideoElement>(null);

  const baseImageUrl = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_1 = `${baseImageUrl}animation_1.png`;
  const rightSideImage_2 = `${baseImageUrl}animation_2.png`;
  const rightSideImage_3 = `${baseImageUrl}animation_3.png`;

  const rightSideComponentBaseStyle: React.CSSProperties = {
    position: "absolute",
    right: 0,
    bottom: 0,
    transition: "opacity .6s ease-in-out",
    height: "100%",
    zIndex: 1,
  };

  useEffect(() => {
    let timeoutId: any;
    if (currentPage === PageId) {
      if (step === 0) timeoutId = setTimeout(() => setStep(step + 1), 600);
    } else setStep(0);

    return () => {
      setStep(0);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    let timeoutId: any;
    let timeoutId2: any;

    if (step === 1) timeoutId = setTimeout(() => setStep(step + 1), 4000);
    if (step === 3) timeoutId2 = setTimeout(() => setStep(1), 2000);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const backButtonConfig = {
    label: "Back",
    type: "back",
    startIcon: { icon: "arrow-right", color: "#fff" },
    onClick: () => setCurrentPage(BackPageId),
    style: { gap: "var(--width-16)" },
  };

  const nextButtonConfig = {
    label: "Next",
    type: "next",
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NextPageId),
    style: { gap: "var(--width-16)" },
  };

  useEffect(() => {
    if (videoRef.current) {
      if (currentPage === PageId && step === 2) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
        if (currentPage !== PageId) videoRef.current.currentTime = 0;
      }
    }
  }, [currentPage, step]);

  return {
    bgVideo: {
      video: `${Config.BASE_URL}/videos/bg_${PageId}.mp4`,
      poster: `${Config.BASE_URL}/images/BG/bg_${PageId}.jpg`,
    },
    gradient: "linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.00) 57%, rgba(255, 255, 255, 0.00) 100%)",
    title: "Hassle-free installation with\njust a QR scan.",
    description: `Gone are the days of complex network setups.\nSimply scan the QR code on your new router,\nand the system will automatically detect your\ndevice, configure settings, and initiate\ninstallation.`,
    leftAfterDescription: (
      <ExtraDescription
        text={`<ul><li>Smart QR Scan – Instantly links your new\ndevice to the network.</li>\n<li>Guided Setup – Step-by-step installation\nprogress displayed in real-time.</li>\n<li>Seamless - Pre-defined modem settings, no\nmanual setup needed.</li>\n<li>Share  - Easily share the WiFi connection with\nfriends and family.</li></ul>`}
      />
    ),
    rightSideComponent: (
      <>
        <img src={rightSideImage_1} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 1 ? 1 : 0 }} />
        <img src={rightSideImage_2} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 2 ? 1 : 0 }} />
        <video
          ref={videoRef}
          autoPlay={false}
          style={{
            transition: "opacity .6s ease",
            opacity: step >= 2 ? 1 : 0,
            position: "absolute",
            zIndex: 1,
            width: "var(--width-388)",
            height: "var(--height-255)",
            right: "var(--width-140)",
            top: "var(--height-190)",
          }}
          onEnded={() => setTimeout(() => setStep(3), 600)}
          src={`${Config.BASE_URL}/videos/screen_3bis.mp4`}
        ></video>
        <img src={rightSideImage_3} alt="" style={{ ...rightSideComponentBaseStyle, opacity: step >= 3 ? 1 : 0, zIndex: 1 }} />
      </>
    ),
    back: backButtonConfig,
    next: nextButtonConfig,
  };
};

export default DATA;
